<template>
    <div class="page_part2">
      <div class="page_mulu content">
        <h5 class="header page_header page_bg_o header_title_page">
          <span>Part.6 职业推荐</span>
        </h5>
        <h6 class="page_title_2">
          <span>职业推荐</span><span class="arrow"></span>
        </h6>
        <div class="header_detail_box">
          <p class="header_detail">
            职业推荐基于标准职业分类体系，经修订后包含20多种职业类别和400多种具体职业，与专业存在对应关系，并包含价值观信息，形成职业库并作为推荐来源。此部分将你的专业推荐结果与职业库进行对照，得到具体职业和类别，参考职业的价值观倾向，助力你形成长程、连续、清晰的发展路径。
          </p>
        </div>
        <div class="line_box2">
          <p>
            <img
              src="../../../../../public/imgs/cepingreport/page_feng.png"
              alt=""
            />
            你的职业推荐结果如下：
          </p>
        </div>
        <div class="echarts">
          <div id="main"></div>
        </div>
      </div>
      <div class="page_mulu">
        <div>
          <div
            class="content elheight '"
            
            v-for="(car, index) in careerRecommend"
            :key="index"
            ref="ele"  
          >
            <div class="zhuanye_one" >
              <div
                class="small_title_box career_page"
                :class="'color' + ++index"
              >
                <span class="career_page"></span>
                <i class="zy_book" :class="'zy_book' + index"></i>
                <div class="small_titled">
                  {{ car.num }}
                </div>
                <div class="line"></div>
                <div class="page_number">
                  {{ car.oneItem }}
                </div>
              </div>
            </div>
            <div class="jz_main">
              <div class="jz_left">
                <div class="jz_left_top">
                  <i cass="jz_top_icon"></i>
                </div>
                <div class="jz_left_center">价值观倾向</div>
                <div class="jz_left_bottom">
                  <ul>
                    <li
                      v-for="(pro, index) in car.professionValue"
                      :key="index"
                      class="jz_left_one"
                      :class="{
                        iconZizhu: pro === '自主型',
                        iconfuwu: pro === '服务型',
                        iconShenghuo: pro === '生活型',
                        iconChuangxin: pro === '创新型',
                        iconTiaozhan: pro === '挑战型',
                        iconAnquan: pro === '安全型',
                        iconGuanli: pro === '管理型',
                        iconJishu: pro === '技术型',
                      }"
                    >
                      <span
                        class="icon_ab"
                        :class="{
                          iconZizhu1: pro === '自主型',
                          iconfuwu1: pro === '服务型',
                          iconShenghuo1: pro === '生活型',
                          iconChuangxin1: pro === '创新型',
                          iconTiaozhan1: pro === '挑战型',
                          iconAnquan1: pro === '安全型',
                          iconGuanli1: pro === '管理型',
                          iconJishu1: pro === '技术型',
                        }"
                        >{{ pro }}</span
                      >
                    </li>
                  </ul>
                </div>
              </div>
              <div class="jz_right">
                <ul>
                  <li
                    class="item"
                    v-for="(two, idx) in car.twoItemValue"
                    :key="idx"
                  >
                    <h5>
                      职业例举{{ idx + 1 }}
                      <span :class="'color' + index">{{ two.two }}</span>
                    </h5>
                    <p>
                      {{ two.job }}
                    </p>
                  </li>
                  <!-- <li class="item">
                        <h5>职业例举2-<span class="page_co_r">休闲娱乐工作人员</span></h5>
                        <p>
                            休闲娱乐工作人员为志愿者机构或娱乐设施场所（如游乐场、公园、水中心和老人中心）设计和引导娱乐休闲活动，如艺术和手工艺、舞蹈、体育冒险项目、音乐和野营。
                        </p>
                    </li> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>   
</template>

<script>
export default {
  props: ["careerRecommend"],
  data() {
    return {
      color: [1, 2, 3, 4, 5, 6, 7, 8],
      Height:'100%',
      height:'472px'
      
    };
  },
  computed:{
      
  },

created(){
    
     
   
},
  updated() {
    
  },
  mounted() {
   
     
    
    // this.drawLine()
    
  },
  methods: {
    
    },
    drawLine() {
      var echarts = require("echarts");
      var myChart = echarts.init(document.getElementById("main"));
      myChart.setOption({
        title: {},
        series: [
          {
            type: "graph",
            layout: "force",
            force: {
              repulsion: 800,
              edgeLength: 50,
            },
            roam: true,
            label: {
              // formatter: function (params,ticket,callback) {
              //     console.log(params)
              // },
              normal: {
                show: true,
                formatter: function (params) {
                  var strs = params.name.split(""); //字符串数组
                  var str = "";
                  for (var i = 0, s; (s = strs[i++]); ) {
                    //遍历字符串数组
                    str += s;
                    if (!(i % 6)) str += "\n\n"; //按需要求余
                  }
                  return str;
                },
              },
            },
            data: [
              {
                name: "职业推荐",
                symbolSize: 120,
                draggable: true,
                category: 0,
                itemStyle: {
                  normal: {
                    color: "#1BCFA0",
                  },
                },
              },
              {
                name: "管理类 96%",
                symbolSize: 100,
                itemStyle: {
                  normal: {
                    color: "#1CA4B6",
                  },
                },
                category: 1,
              },
              {
                name: "社区和社会服务类 94%",
                symbolSize: 100,
                itemStyle: {
                  normal: {
                    color: "#5CBF98",
                  },
                },
                category: 1,
              },
              {
                name: "法律92%",
                symbolSize: 100,
                category: 2,
                itemStyle: {
                  normal: {
                    color: "#47B7EA",
                  },
                },
              },

              {
                name: "艺术、设计、 娱乐、体育 和传媒类 100%",
                symbolSize: 100,
                category: 2,
                itemStyle: {
                  normal: {
                    color: "#F57450",
                  },
                },
              },
              {
                name: "教育、培训 和图书馆类 98%",
                symbolSize: 100,
                category: 2,
                itemStyle: {
                  normal: {
                    color: "#F6A724",
                  },
                },
              },
              {
                name: "个人护理 和服务类 90%",
                symbolSize: 100,
                category: 2,
                itemStyle: {
                  normal: {
                    color: "#C7CE22",
                  },
                },
              },
              {
                name: "休闲娱乐 工作人员",
                symbolSize: 80,
                category: 1,
                itemStyle: {
                  normal: {
                    color: "#F57450",
                  },
                },
              },
              {
                name: "播音员",
                symbolSize: 80,
                category: 1,
                itemStyle: {
                  normal: {
                    color: "#F57450",
                  },
                },
              },
              {
                name: "餐饮服务 经理",
                symbolSize: 80,
                category: 1,
                itemStyle: {
                  normal: {
                    color: "#1CA4B6",
                  },
                },
              },
              {
                name: "应急管理 总监",
                symbolSize: 80,
                category: 1,
                itemStyle: {
                  normal: {
                    color: "#1CA4B6",
                  },
                },
              },
              {
                name: "高中老师",
                symbolSize: 80,
                category: 2,
                itemStyle: {
                  normal: {
                    color: "#F6A724",
                  },
                },
              },
              {
                name: "成人基础 教育和 高中学历 老师",
                symbolSize: 80,
                category: 2,
                itemStyle: {
                  normal: {
                    color: "#F6A724",
                  },
                },
              },
              {
                name: "自学教育 老师",
                symbolSize: 80,
                category: 2,
                itemStyle: {
                  normal: {
                    color: "#F6A724",
                  },
                },
              },
              {
                name: "导游和领队",
                symbolSize: 80,
                category: 2,
                itemStyle: {
                  normal: {
                    color: "#C7CE22",
                  },
                },
              },

              {
                name: "仲裁员、中间人、调解员",
                symbolSize: 80,
                category: 2,
                itemStyle: {
                  normal: {
                    color: "#47B7EA",
                  },
                },
              },
              {
                name: "健康教育 和社区卫生 工作者",
                symbolSize: 80,
                category: 2,
                itemStyle: {
                  normal: {
                    color: "#5CBF98",
                  },
                },
              },
              {
                name: "社会工作 人员",
                symbolSize: 80,
                category: 2,
                itemStyle: {
                  normal: {
                    color: "#5CBF98",
                  },
                },
              },
              {
                name: "婚姻和家庭 治疗师",
                symbolSize: 80,
                category: 2,
                itemStyle: {
                  normal: {
                    color: "#5CBF98",
                  },
                },
              },
            ],
            links: [
              {
                source: "职业推荐",
                target: "管理类 96%",
              },
              {
                source: "职业推荐",
                target: "法律92%",
              },
              {
                source: "法律92%",
                target: "仲裁员、中间人、调解员",
              },
              {
                source: "职业推荐",
                target: "社区和社会服务类 94%",
              },
              {
                source: "社区和社会服务类 94%",
                target: "健康教育 和社区卫生 工作者",
              },
              {
                source: "社区和社会服务类 94%",
                target: "社会工作 人员",
              },
              {
                source: "社区和社会服务类 94%",
                target: "婚姻和家庭 治疗师",
              },
              {
                source: "职业推荐",
                target: "艺术、设计、 娱乐、体育 和传媒类 100%",
              },
              {
                source: "艺术、设计、 娱乐、体育 和传媒类 100%",
                target: "休闲娱乐 工作人员",
              },
              {
                source: "艺术、设计、 娱乐、体育 和传媒类 100%",
                target: "播音员",
              },
              {
                source: "职业推荐",
                target: "教育、培训 和图书馆类 98%",
              },
              {
                source: "教育、培训 和图书馆类 98%",
                target: "高中老师",
              },
              {
                source: "教育、培训 和图书馆类 98%",
                target: "成人基础 教育和 高中学历 老师",
              },
              {
                source: "教育、培训 和图书馆类 98%",
                target: "自学教育 老师",
              },
              {
                source: "职业推荐",
                target: "个人护理 和服务类 90%",
              },
              {
                source: "个人护理 和服务类 90%",
                target: "导游和领队",
              },
              {
                source: "职业推荐",
                target: "社区和\n社会服务类 94%",
              },

              {
                source: "管理类 96%",
                target: "餐饮服务 经理",
              },
              {
                source: "管理类 96%",
                target: "应急管理 总监",
              },
              {
                source: "职业推荐",
                target: "管理类 92%",
              },
            ],
            lineStyle: {
              normal: {
                opacity: 0.9,
                width: 1,
                curveness: 0,
              },
            },
            categories: [{ name: "0" }, { name: "1" }, { name: "2" }],
          },
        ],
      });
    },
};
</script>

<style scoped>
@import "./report.css";
.cepingReport .page {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
    padding: 80px 90px;
    width: 900px;
    height: 1279.3px;
    margin-bottom: 20px;
    /* position: relative; */
    /* overflow: hidden; */
}
.blank_page{
  width: 100%;
  height: 300px;
}
#main {
  width: 100%;
  height: 800px;
}
.jz_main {
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
}
.elheight {
  height: auto;
  min-height: 472px;
}


.userclass {
}
.jz_left {
  width: 219px;
  height: 278px;
  background: rgba(235, 235, 235, 0.23);
  border-radius: 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.jz_right {
  width: 412px;
}
.jz_right ul .item {
  margin-bottom: 30px;
}
.jz_right ul .item h5 {
  font-size: 15px;
  font-weight: 600;
}
.jz_right ul .item p {
  font-size: 14px;
  color: rgba(107, 107, 107, 0.8);
  margin-top: 15px;
}
.page_co_r {
  color: #f57450;
}
.page_co_b {
  color: #1ca4b6;
}
.page_co_bl {
  color: #47b7ea;
}
.page_co_o {
  color: #f6a724;
}
.page_co_g {
  color: #aacf00;
}
.page_co_gr {
  color: #1bcfa0;
}
.page_co_z {
  color: #5695ff;
}

.jz_top_icon {
  display: inline-block;
  width: 92px;
  height: 92px;
  background: url("../../../../../public/imgs/cepingreport/page_3_21.png")
    no-repeat;
}
.iconZizhu {
  display: inline-block;
  width: 58px;
  height: 80px;
  background: url("../../../../../public/imgs/cepingreport/iconZizhu.png")
    no-repeat;
}
.iconZizhu1 {
  color: #1ca4b6;
}
.iconfuwu {
  width: 58px;
  height: 80px;
  background: url("../../../../../public/imgs/cepingreport/iconFuwu.png")
    no-repeat;
  background-size: cover;
}
.iconfuwu1 {
  color: #f57450;
}
.iconGuanli {
  width: 58px;
  height: 80px;
  background: url("../../../../../public/imgs/cepingreport/iconGuanli.png")
    no-repeat;
  background-size: cover;
}
.iconGuanli1 {
  color: #5695ff;
}
.iconChuangxin {
  width: 58px;
  height: 80px;
  background: url("../../../../../public/imgs/cepingreport/iconChuangxin.png")
    no-repeat;
  background-size: cover;
}
.iconChuangxin1 {
  color: #47b7ea;
}
.iconAnquan {
  width: 58px;
  height: 80px;
  background: url("../../../../../public/imgs/cepingreport/iconAnquan.png")
    no-repeat;
  background-size: cover;
}
.iconAnquan1 {
  color: #1bcfa0;
}
.iconShenghuo {
  width: 58px;
  height: 80px;
  background: url("../../../../../public/imgs/cepingreport/iconShenghuo.png")
    no-repeat;
  background-size: cover;
}
.iconShenghuo1 {
  color: #feae3b;
}
.iconTiaozhan {
  width: 58px;
  height: 80px;
  background: url("../../../../../public/imgs/cepingreport/iconTiaozhan.png")
    no-repeat;
  background-size: cover;
}
.iconTiaozhan1 {
  color: #aacf00;
}
.iconJishu {
  width: 58px;
  height: 80px;
  background: url("../../../../../public/imgs/cepingreport/iconJishu.png")
    no-repeat;
  background-size: cover;
}
.iconJishu1 {
  color: #7d93ff;
}

.jz_left_bottom ul {
  display: flex;
  justify-content: space-evenly;
}
.jz_left_bottom ul li span {
  font-size: 14px;
}
.jz_left_center {
  position: relative;
  font-size: 16px;
  font-weight: 600;
}
.jz_left_center::after,
.jz_left_center::before {
  content: "";
  position: absolute; /*定位背景横线的位置*/
  top: 50%;
  background: #8c8c8c; /*背景横线颜色*/
  width: 10%; /*单侧横线的长度*/
  height: 1px;
}
.jz_left_center::after {
  left: 18%;
}
.jz_left_center::before {
  right: 18%;
}
.icon_ab {
  position: relative;
  top: 50px;
}

h5.page_bg_o {
  background-color: #feae3b;
}

h5.header {
  color: #fff;
  font-size: 24px;
  text-align: left;
  margin-bottom: 30px;
  line-height: 50px;
  padding-left: 15px;
}
.page_title_2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 32px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 10px;
}
.page_title_2 .arrow {
}
.page_title_2 span {
  line-height: 32px;
  font-size: 20px;
  font-weight: 700;
}
.page_title_2 .arrow {
  display: block;
  margin-left: 10px;
  width: 0;
  height: 0;
  border-top: 9px solid transparent;
  border-left: 14px solid #feae3b;
  /* border-left: 14px solid #19b1c4; */
  border-bottom: 9px solid transparent;
}
.header_detail_box .header_detail {
  text-indent: 2em;
  line-height: 32px;
  font-size: 15px;
  color: #4f4e4e;
}

.line_box2 {
  margin-top: 40px;
}
.zhuanye_one .small_titled,
.zhuanye_one .page_number {
  font-size: 20px;
}
.zhuanye_one {
  margin: 20px 0 30px 0;
}
.page_co_r {
  color: #f57450;
}
.small_title_box {
  font-size: 16px;
  /* color: #3AB3C1; */
  line-height: 28px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  font-weight: 600;
}
.small_title_box .small_titled {
  padding-right: 20px;

  padding-left: 15px;
}
.small_title_box .line {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  border-top: 2px dotted #aeadad;
  margin: auto 0;
}
.small_title_box .page_number {
  padding-left: 10px;
  /* font-size: 18px; */
}
/* .zy_book{
    display: inline-block;
    width: 37px;
    height: 33px;
    background: url("../../../../../public/imgs/cepingreport/page_2_5.png")no-repeat;
    background-size: cover;
} */
</style>